var map = {
	"./account-opening-statement/index.vue": [
		"95a9",
		"chunk-7e7397e2",
		"chunk-c93745f4"
	],
	"./account-type/index.vue": [
		"5ef9",
		"chunk-37666ceb"
	],
	"./bind-card/index.vue": [
		"692f",
		"chunk-bdc9403e",
		"chunk-911f2b26"
	],
	"./captcha/index.vue": [
		"1ca8",
		"chunk-3f760318"
	],
	"./confirm/index.vue": [
		"638d",
		"chunk-516b662e"
	],
	"./contact-info/index.vue": [
		"8cea",
		"chunk-bdc9403e",
		"chunk-2d0c1919",
		"chunk-83babcca"
	],
	"./financial-info/index.vue": [
		"a1a9",
		"chunk-bdc9403e",
		"chunk-47285886"
	],
	"./guide/index.vue": [
		"7320",
		"chunk-2d0d6710"
	],
	"./home/components/openAccount.vue": [
		"b5cd",
		"chunk-8d36a3c0"
	],
	"./home/index.vue": [
		"7abe",
		"chunk-84668e48"
	],
	"./id-card-info/index.vue": [
		"25de7",
		"chunk-bdc9403e",
		"chunk-2d0c1919",
		"chunk-dde802ec"
	],
	"./id-card/index.vue": [
		"72a9",
		"chunk-bdc9403e",
		"chunk-2d0c1919",
		"chunk-48570f19"
	],
	"./id-type/index.vue": [
		"ec5e",
		"chunk-f639ffba"
	],
	"./layout/index.vue": [
		"162e"
	],
	"./mainland-declaration/index.vue": [
		"600d",
		"chunk-338b4886"
	],
	"./other/ components/DataInput.vue": [
		"91c2",
		"chunk-bdc9403e",
		"chunk-2d0c1919",
		"chunk-95aa01de",
		"chunk-04bf56a4"
	],
	"./other/ components/PersonInfo.vue": [
		"db34",
		"chunk-2d0c1919",
		"chunk-95aa01de"
	],
	"./other/index.vue": [
		"bf72",
		"chunk-bdc9403e",
		"chunk-2d0c1919",
		"chunk-95aa01de",
		"chunk-04bf56a4",
		"chunk-29a1096d"
	],
	"./pi-ar/index.vue": [
		"325b",
		"chunk-bdc9403e",
		"chunk-7d839062"
	],
	"./pi-risk/index.vue": [
		"ca12",
		"chunk-54cb592c"
	],
	"./pi/index.vue": [
		"5fd1",
		"chunk-525e42a0"
	],
	"./reason/index.vue": [
		"d64f",
		"chunk-9abde9de"
	],
	"./risk/index.vue": [
		"d2d7",
		"chunk-bd7894b4"
	],
	"./signature/index.vue": [
		"1419",
		"chunk-bdc9403e",
		"chunk-fb2854c0"
	],
	"./statement/index.vue": [
		"9ef8",
		"chunk-c28d5ec0"
	],
	"./status/components/ReasonStatus.vue": [
		"8059",
		"chunk-8496e478"
	],
	"./status/index.vue": [
		"4a1f",
		"chunk-55faa237"
	],
	"./tax-info/components/TaxCard.vue": [
		"4e1f",
		"chunk-dfda0062"
	],
	"./tax-info/index.vue": [
		"4ac3",
		"chunk-2a80a16c"
	],
	"./transfer-pro/index.vue": [
		"442c",
		"chunk-bdc9403e",
		"chunk-2d0c1919",
		"chunk-7e7397e2",
		"chunk-0e0274fa"
	],
	"./transfer-step/index.vue": [
		"f6c4",
		"chunk-3d31c465"
	],
	"./transfer/components/TransferItem.vue": [
		"c28a",
		"chunk-2d0c1919",
		"chunk-5a4b66f6"
	],
	"./transfer/index.vue": [
		"8034",
		"chunk-2d0c1919",
		"chunk-0deb442f"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "ce9f";
module.exports = webpackAsyncContext;